import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuthStore } from "../state/authStore"
import { useDeviceStore } from "../state/deviceStore"
import { getActiveOrders, type ActiveOrder } from "../api/orders"

export default function ActiveOrdersPage() {
  const navigate = useNavigate()
  const token = useAuthStore(s => s.token)!
  const deviceUuid = useDeviceStore(s => s.deviceUuid)!
  const [orders, setOrders] = useState<ActiveOrder[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const load = () => {
      getActiveOrders(token, deviceUuid)
        .then(setOrders)
        .catch(() => {})
        .finally(() => setLoading(false))
    }
    load()
    const interval = setInterval(load, 10000)
    return () => clearInterval(interval)
  }, [token, deviceUuid])

  return (
    <div className="flex-1 flex flex-col">
      <header className="bg-primary-900 text-white px-4 py-3 flex items-center gap-3">
        <button onClick={() => navigate("/order")} className="text-white">←</button>
        <h1 className="font-semibold">Aktivne narudžbe</h1>
      </header>
      <div className="flex-1 overflow-y-auto p-4">
        {loading && <div className="text-center text-slate-500">Učitavam...</div>}
        {!loading && orders.length === 0 && <div className="text-center text-slate-500 mt-8">Nema aktivnih narudžbi.</div>}
        <div className="space-y-3 max-w-2xl mx-auto">
          {orders.map(o => (
            <div key={o.brojNarudzbe} className="bg-white rounded-lg shadow-sm border border-slate-200 p-4">
              <div className="flex items-center justify-between mb-2">
                <div className="font-semibold text-slate-800">Narudžba #{o.brojNarudzbe}</div>
                <div className="text-sm text-slate-500">
                  {new Date(o.datumVrijeme).toLocaleTimeString("bs-BA", { hour: "2-digit", minute: "2-digit" })}
                </div>
              </div>
              <div className="space-y-1">
                {o.stavke.map((s, i) => (
                  <div key={i} className="flex items-center gap-2 text-sm">
                    <span className={`inline-block w-2 h-2 rounded-full ${s.aktivno ? "bg-orange-400" : "bg-green-500"}`}></span>
                    <span className="font-medium">{s.kolicina}×</span>
                    <span className="flex-1 text-slate-700">{s.artikal}</span>
                    <span className="text-xs text-slate-400">{s.aktivno ? "čeka" : "spremno"}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
